import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import { MdArrowForwardIos, MdImage, MdMenu } from "react-icons/md";

import "../styles/Imprint.css";
import { useLocation, useNavigate } from "react-router";

export default function AGB({ apiURL }) {
  const location = useLocation().pathname;
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="imprint">
      <div className="imprint_topnav">
        <div className="imprint_topnav_left">
          <div className="home_topnav_left_back" onClick={() => navigate("/")}>
            Return
          </div>
        </div>
      </div>
      <div className="imprint_body">
        <h1>Allgemeine Geschäftsbedingungen und Kundeninformationen</h1>

        <h2>I. Allgemeine Geschäftsbedingungen</h2>

        <h3>§ 1 Grundlegende Bestimmungen</h3>
        <p>
          (1) Die nachstehenden Geschäftsbedingungen gelten für Verträge, die
          Sie mit uns als Anbieter (<strong>Servist Software GmbH</strong>) über
          die Internetseite <strong>www.servist.de</strong> schließen. Soweit
          nicht anders vereinbart, wird der Einbeziehung gegebenenfalls von
          Ihnen verwendeter eigener Bedingungen widersprochen.
        </p>
        <p>
          (2) Verbraucher im Sinne der nachstehenden Regelungen ist jede
          natürliche Person, die ein Rechtsgeschäft zu Zwecken abschließt, die
          überwiegend weder ihrer gewerblichen noch ihrer selbständigen
          beruflichen Tätigkeit zugerechnet werden kann. Unternehmer ist jede
          natürliche oder juristische Person oder eine rechtsfähige
          Personengesellschaft, die bei Abschluss eines Rechtsgeschäfts in
          Ausübung ihrer selbständigen beruflichen oder gewerblichen Tätigkeit
          handelt.
        </p>

        <h3>§ 2 Zustandekommen des Vertrages</h3>
        <p>(1) Gegenstand des Vertrages ist der Verkauf von Waren.</p>
        <p>
          (2) Bereits mit dem Einstellen des jeweiligen Produkts auf unserer
          Internetseite unterbreiten wir Ihnen ein verbindliches Angebot zum
          Abschluss eines Vertrages über das Online-Warenkorbsystem zu den in
          der Artikelbeschreibung angegebenen Bedingungen.
        </p>
        <p>
          (3) Der Vertrag kommt über das Online-Warenkorbsystem wie folgt
          zustande: Die zum Kauf beabsichtigten Waren werden im "Warenkorb"
          abgelegt. Über die entsprechende Schaltfläche in der Navigationsleiste
          können Sie den "Warenkorb" aufrufen und dort jederzeit Änderungen
          vornehmen.
        </p>
        <p>
          Nach Anklicken der Schaltfläche "Kasse" oder "Weiter zur Bestellung"
          (oder ähnliche Bezeichnung) und der Eingabe der persönlichen Daten
          sowie der Zahlungs- und Versandbedingungen werden Ihnen abschließend
          die Bestelldaten als Bestellübersicht angezeigt.
        </p>
        <p>
          Soweit Sie als Zahlungsart ein Sofortzahl-System (z. B. PayPal,
          Klarna, Kreditkarte) nutzen, werden Sie entweder auf die
          Bestellübersichtsseite in unserem Online-Shop geführt oder auf die
          Internetseite des Anbieters des Sofortzahl-Systems weitergeleitet.
          Erfolgt eine Weiterleitung zu dem jeweiligen Sofortzahl-System, nehmen
          Sie dort die entsprechende Auswahl bzw. Eingabe Ihrer Daten vor.
          Abschließend werden Ihnen auf der Internetseite des Anbieters des
          Sofortzahl-Systems oder nachdem Sie zurück in unseren Online-Shop
          geleitet wurden, die Bestelldaten als Bestellübersicht angezeigt.
        </p>
        <p>
          Vor Absenden der Bestellung haben Sie die Möglichkeit, die Angaben in
          der Bestellübersicht nochmals zu überprüfen, zu ändern (auch über die
          Funktion "zurück" des Internetbrowsers) bzw. die Bestellung
          abzubrechen.
        </p>
        <p>
          Mit dem Absenden der Bestellung über die entsprechende Schaltfläche
          ("zahlungspflichtig bestellen", "kaufen" / "jetzt kaufen",
          "kostenpflichtig bestellen", "bezahlen" / "jetzt bezahlen" oder
          ähnliche Bezeichnung) erklären Sie rechtsverbindlich die Annahme des
          Angebotes, wodurch der Vertrag zustande kommt.
        </p>
        <p>
          (4) Ihre Anfragen zur Erstellung eines Angebotes sind für Sie
          unverbindlich. Wir unterbreiten Ihnen hierzu ein verbindliches Angebot
          in Textform (z. B. per E-Mail), welches Sie innerhalb von 5 Tagen
          (soweit im jeweiligen Angebot keine andere Frist ausgewiesen ist)
          annehmen können.
        </p>
        <p>
          (5) Die Abwicklung der Bestellung und Übermittlung aller im
          Zusammenhang mit dem Vertragsschluss erforderlichen Informationen
          erfolgt per E-Mail zum Teil automatisiert. Sie haben deshalb
          sicherzustellen, dass die von Ihnen bei uns hinterlegte E-Mail-Adresse
          zutreffend ist, der Empfang der E-Mails technisch sichergestellt und
          insbesondere nicht durch SPAM-Filter verhindert wird.
        </p>

        <h3>§ 3 Zurückbehaltungsrecht, Eigentumsvorbehalt</h3>
        <p>
          (1) Ein Zurückbehaltungsrecht können Sie nur ausüben, soweit es sich
          um Forderungen aus demselben Vertragsverhältnis handelt.
        </p>
        <p>
          (2) Die Ware bleibt bis zur vollständigen Zahlung des Kaufpreises
          unser Eigentum.
        </p>

        <h3>§ 4 Gewährleistung</h3>
        <p>(1) Es bestehen die gesetzlichen Mängelhaftungsrechte.</p>
        <p>
          (2) Als Verbraucher werden Sie gebeten, die Ware bei Lieferung
          umgehend auf Vollständigkeit, offensichtliche Mängel und
          Transportschäden zu überprüfen und uns sowie dem Spediteur
          Beanstandungen schnellstmöglich mitzuteilen. Kommen Sie dem nicht
          nach, hat dies keine Auswirkung auf Ihre gesetzlichen
          Gewährleistungsansprüche.
        </p>
        <p>
          (3) Soweit ein Merkmal der Ware von den objektiven Anforderungen
          abweicht, gilt die Abweichung nur dann als vereinbart, wenn Sie vor
          Abgabe der Vertragserklärung durch uns über selbige in Kenntnis
          gesetzt wurden und die Abweichung ausdrücklich und gesondert zwischen
          den Vertragsparteien vereinbart wurde.
        </p>

        <h3>§ 5 Rechtswahl, Erfüllungsort, Gerichtsstand</h3>
        <p>
          (1) Es gilt deutsches Recht. Bei Verbrauchern gilt diese Rechtswahl
          nur, soweit hierdurch der durch zwingende Bestimmungen des Rechts des
          Staates des gewöhnlichen Aufenthaltes des Verbrauchers gewährte Schutz
          nicht entzogen wird (Günstigkeitsprinzip).
        </p>
        <p>
          (2) Erfüllungsort für alle Leistungen aus den mit uns bestehenden
          Geschäftsbeziehungen sowie Gerichtsstand ist unser Sitz, soweit Sie
          nicht Verbraucher, sondern Kaufmann, juristische Person des
          öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen sind.
          Dasselbe gilt, wenn Sie keinen allgemeinen Gerichtsstand in
          Deutschland oder der EU haben oder der Wohnsitz oder gewöhnliche
          Aufenthalt im Zeitpunkt der Klageerhebung nicht bekannt ist. Die
          Befugnis, auch das Gericht an einem anderen gesetzlichen Gerichtsstand
          anzurufen, bleibt hiervon unberührt.
        </p>
        <p>
          (3) Die Bestimmungen des UN-Kaufrechts finden ausdrücklich keine
          Anwendung.
        </p>

        <h2>II. Kundeninformationen</h2>

        <h3>1. Identität des Verkäufers</h3>
        <p>
          <strong>Servist Software GmbH</strong>
          <br />
          Neißestraße 1<br />
          14513 Teltow
          <br />
          Deutschland
        </p>
        <p>
          Telefon: +49 15562 175400
          <br />
          E-Mail: info@servist.de
        </p>

        <p>
          Alternative Streitbeilegung:
          <br />
          Die Europäische Kommission stellt eine Plattform für die
          außergerichtliche Online-Streitbeilegung (OS-Plattform) bereit,
          aufrufbar unter{" "}
          <a href="https://ec.europa.eu/odr" target="_blank">
            https://ec.europa.eu/odr
          </a>
          .
        </p>
        <p>
          Wir sind bereit, an Streitbeilegungsverfahren vor
          Verbraucherschlichtungsstellen teilzunehmen.
        </p>

        <h3>2. Informationen zum Zustandekommen des Vertrages</h3>
        <p>
          Die technischen Schritte zum Vertragsschluss, der Vertragsschluss
          selbst und die Korrekturmöglichkeiten erfolgen nach Maßgabe der
          Regelungen „Zustandekommen des Vertrages“ unserer Allgemeinen
          Geschäftsbedingungen (Teil I).
        </p>

        <h3>3. Vertragssprache, Vertragstextspeicherung</h3>
        <p>
          3.1. Vertragssprache ist <strong>Deutsch</strong>.
        </p>
        <p>
          3.2. Der vollständige Vertragstext wird von uns nicht gespeichert. Vor
          Absenden der Bestellung über das Online-Warenkorbsystem können die
          Vertragsdaten über die Druckfunktion des Browsers ausgedruckt oder
          elektronisch gesichert werden. Nach Zugang der Bestellung bei uns
          werden die Bestelldaten, die gesetzlich vorgeschriebenen Informationen
          bei Fernabsatzverträgen und die Allgemeinen Geschäftsbedingungen
          nochmals per E-Mail an Sie übersandt.
        </p>
        <p>
          3.3. Bei Angebotsanfragen außerhalb des Online-Warenkorbsystems
          erhalten Sie alle Vertragsdaten im Rahmen eines verbindlichen
          Angebotes in Textform übersandt, z. B. per E-Mail, welche Sie
          ausdrucken oder elektronisch sichern können.
        </p>

        <h3>4. Verhaltenskodizes</h3>
        <p>Wir haben uns keinen besonderen Verhaltenskodizes unterworfen.</p>

        <h3>5. Wesentliche Merkmale der Ware oder Dienstleistung</h3>
        <p>
          Die wesentlichen Merkmale der Ware finden sich im jeweiligen Angebot.
        </p>

        <h3>6. Preise und Zahlungsmodalitäten</h3>
        <p>
          6.1. Die in den jeweiligen Angeboten angeführten Preise stellen
          Gesamtpreise dar. Sie beinhalten alle Preisbestandteile einschließlich
          der gesetzlichen Mehrwertsteuer.
        </p>
        <p>
          6.2. Die Versandkosten betragen pauschal <strong>5,99 €</strong>,
          soweit nicht im Angebot ausdrücklich eine versandkostenfreie Lieferung
          angegeben ist.
        </p>
        <p>
          6.3. Die Ihnen zur Verfügung stehenden Zahlungsarten sind PayPal,
          Klarna und Kreditkarte.
        </p>
        <p>
          6.4. Soweit bei den einzelnen Zahlungsarten nicht anders angegeben,
          sind die Zahlungsansprüche aus dem geschlossenen Vertrag sofort zur
          Zahlung fällig.
        </p>

        <h3>7. Lieferbedingungen</h3>
        <p>7.1. Die Lieferung erfolgt ausschließlich innerhalb Deutschlands.</p>
        <p>7.2. Der Versand erfolgt über DHL.</p>
        <p>
          7.3. Lieferzeit beträgt, soweit im Angebot nicht anders angegeben, ca.
          2–3 Werktage nach Zahlungseingang.
        </p>
        <p>
          7.4. Soweit Sie Verbraucher sind, geht die Gefahr des zufälligen
          Untergangs und der zufälligen Verschlechterung der verkauften Sache
          während der Versendung erst mit der Übergabe der Ware an Sie über.
          Dies gilt nicht, wenn Sie eigenständig ein nicht vom Unternehmer
          benanntes Transportunternehmen oder eine sonst zur Ausführung der
          Versendung bestimmte Person beauftragt haben.
        </p>

        <h3>8. Gesetzliches Mängelhaftungsrecht</h3>
        <p>
          Die Mängelhaftung richtet sich nach der Regelung „Gewährleistung“ in
          unseren Allgemeinen Geschäftsbedingungen (Teil I).
        </p>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ImageIcon = styled(MdImage)`
  font-size: 42px;
  color: #474747;
`;
